import React from 'react';
import './PostSkeleton.css';

export default function PostSkeleton() {
  return (
    <div className='skeleton-post-wraper'>
      <div className='post-skeleton'>
        <div className='post-items-wrapper'>
          <div className='post-item-skeleton'>
            <div className='skeleton-item-left topup-type-text-skeleton'></div>
            <div className='skeleton-item-left post-item-pic-skeleton'></div>
          </div>
          <div className='post-item-skeleton'>
            <div className='skeleton-item-right topup-type-text-skeleton'></div>
            <div className='skeleton-item-right post-item-pic-skeleton'></div>
          </div>
        </div>
        <div className='seller-contacts-post-actions-skeleton-wraper'>
          <div className='seller-location-time-skeleton-wrapper'>
            <div className='info-card-skeleton-wrapper'>
              <div className='skeleton-item-left info-card-img-skeleton'></div>
              <div className='skeleton-item-left info-card-text-skeleton'></div>
            </div>
            <div className='info-card-skeleton-wrapper'>
              <div className='skeleton-item-left info-card-img-skeleton'></div>
              <div className='skeleton-item-left info-card-text-skeleton'></div>
            </div>
            <div className='info-card-skeleton-wrapper'>
              <div className='skeleton-item-left info-card-img-skeleton'></div>
              <div className='skeleton-item-left info-card-text-skeleton'></div>
            </div>
          </div>
          <div className='contactBtns-star-share-skeleton-wrapper'>
            <div className='contact-btns-skeleton-wrapper'>
              <div className='skeleton-item-right contact-btn-skeleton'></div>
              <div className='skeleton-item-right contact-btn-skeleton'></div>
              <div className='skeleton-item-right contact-btn-skeleton'></div>
            </div>
            <div className='star-share-skeleton-wrapper'>
              <div className='star-share-element-wrapper-skeleton'>
                <div className='skeleton-item-right star-share-icon-skeleton'></div>
                <div className='skeleton-item-right star-share-text'></div>
              </div>
              <div className='star-share-element-wrapper-skeleton'>
                <div className='skeleton-item-right star-share-icon-skeleton'></div>
                <div className='skeleton-item-right star-share-text'></div>
              </div>
              <div className='star-share-element-wrapper-skeleton'>
                <div className='skeleton-item-right star-share-icon-skeleton'></div>
                <div className='skeleton-item-right star-share-text'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
